import state from '~store/modules/loading/state'
import actions from '~store/modules/loading/actions'
import mutations from '~store/modules/loading/mutations'
import getters from '~store/modules/loading/getters'

export default {
  state,
  actions,
  mutations,
  getters
}
